import { ReactElement } from "react";

export const RewindIcon = (color?: string): ReactElement => (
  <svg fill="none" height={20} width={20} xmlns="http://www.w3.org/2000/svg">
    <g stroke={color ?? '#5d6a86'} strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.4}>
      <path d="M10.056 9.334a.833.833 0 0 0 0 1.333L14.5 14a.833.833 0 0 0 1.333-.667V6.667A.833.833 0 0 0 14.5 6zM3.389 9.334a.833.833 0 0 0 0 1.333L7.833 14a.833.833 0 0 0 1.334-.667V6.667A.833.833 0 0 0 7.833 6z" />
    </g>
  </svg>
);
